/* LungVera storefront script: purchase box (variant options → Shopify variant, Buy 1 / 2 / 3 offers priced from the
   store's Kaching deal, Add to Cart / straight to checkout), product gallery, tabs, sticky bar, in-page links,
   the star summary and the rotating top bar. Loaded (deferred) on every page by sections/lv-bar.liquid. */
(function () {
  if (window.lvInit) return;
  window.lvInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }
  function readJSON(root, sel) {
    var el = root.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function route(name, fallback) {
    return ((window.routes && window.routes[name]) || rootUrl() + fallback).replace(/\.js$/, '').replace(/\/$/, '') + '.js';
  }
  function scrollBehavior() { return reduceMotion ? 'auto' : 'smooth'; }
  function sizeToken(value) { return String(value || '').trim().split(/\s+/)[0].toUpperCase(); }

  /* ---------------------------------------------------------------
     Kaching deal → offer prices (cents) by quantity, for this product
     --------------------------------------------------------------- */
  function kachingPrices(productId, unit) {
    var out = {};
    var blocks = document.querySelectorAll('script.kaching-bundles-deal-block-settings');
    for (var i = 0; i < blocks.length; i++) {
      var pid = blocks[i].getAttribute('data-product-id');
      if (pid && String(pid) !== String(productId)) continue;
      var deal;
      try { deal = JSON.parse(blocks[i].textContent); } catch (e) { continue; }
      var bars = (deal && deal.dealBars) || [];
      for (var j = 0; j < bars.length; j++) {
        var b = bars[j];
        if (b.dealBarType && b.dealBarType !== 'quantity-break') continue;
        if (!b.quantity || out[b.quantity]) continue;
        var full = unit * b.quantity, price = null;
        if (b.discountType === 'specific') price = Math.round(b.discountValue * 100);
        else if (b.discountType === 'percentage') price = Math.round(full * (1 - b.discountValue / 100));
        else if (b.discountType === 'fixed' || b.discountType === 'amount') price = Math.round(full - b.discountValue * 100);
        else if (b.discountType === 'default') price = full;
        if (price !== null && price > 0 && price <= full) out[b.quantity] = price;
      }
    }
    return out;
  }

  /* ---------------------------------------------------------------
     Purchase box: options → variant, offer cards (1 / 2 / 3 bottles), one choice per unit when the product has options
     --------------------------------------------------------------- */
  function Picker(root) {
    this.root = root;
    this.cfg = readJSON(root, '[data-lv-config]') || {};
    this.variants = this.cfg.variants || [];
    this.optionInfo = this.cfg.options || [];
    this.groups = [].slice.call(root.querySelectorAll('[data-lv-option]'));
    this.offers = !!this.cfg.offers && !!root.querySelector('[data-lv-offer]');
    // Pickers hidden: options are chosen per unit inside the offer cards, and unit 1 drives price, photo and URL
    this.hide = this.offers && !!this.cfg.hide_pickers;
    this.sizeIdx = this.groups.map(function (g) { return g.classList.contains('lv-opt--size'); }).indexOf(true);
    this.qty = this.offers ? (parseInt(this.cfg.default_offer, 10) || 1) : 1;
    var params = new URLSearchParams(window.location.search);
    var fromUrl = parseInt(params.get('bundle'), 10);
    if (this.offers && fromUrl >= 1 && fromUrl <= 3) this.qty = fromUrl;
    var box = root.querySelector('[data-lv-insurance]');
    this.insurance = box ? box.checked : false;
    // ?size=XXL (from the size guide on another page) preselects that size
    var wanted = params.get('size');
    if (wanted) this.pickSize(wanted, true);
    this.resetMats();
    this.loadPrices();
    this.bind();
    this.renderMats();
    this.update(false);
  }

  Picker.prototype.selected = function () {
    return this.groups.map(function (g) {
      var c = g.querySelector('input:checked');
      return c ? c.value : null;
    });
  };

  Picker.prototype.match = function (values) {
    return this.variants.filter(function (v) {
      return values.every(function (val, i) { return val === null || v.options[i] === val; });
    })[0] || null;
  };

  // Every unit in the offer follows the main option pickers until it is changed on its own
  Picker.prototype.resetMats = function () {
    var sel = this.selected();
    this.mats = [sel.slice(), sel.slice(), sel.slice()];
  };

  Picker.prototype.loadPrices = function () {
    var unit = (this.variant || this.match(this.selected()) || this.variants[0] || {}).price || 0;
    var live = kachingPrices(this.cfg.product_id, unit);
    this.live = Object.keys(live).length > 0;
    this.prices = {};
    for (var n = 1; n <= 3; n++) {
      var fallback = this.cfg.fallback && this.cfg.fallback[n - 1];
      this.prices[n] = n === 1 ? unit : (live[n] || fallback || unit * n);
    }
  };

  Picker.prototype.label = function (optIndex, value) {
    var info = this.optionInfo[optIndex];
    var pair = info && info.values.filter(function (p) { return p[0] === value; })[0];
    return pair ? pair[1] : value;
  };

  Picker.prototype.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-lv-insurance]')) { self.insurance = t.checked; self.update(false); return; }
      if (t.matches('[data-lv-offer-input]')) { self.qty = parseInt(t.value, 10) || 1; self.renderMats(); self.update(false); return; }
      if (t.matches('[data-lv-mat-select]')) {
        var m = parseInt(t.getAttribute('data-mat'), 10), o = parseInt(t.getAttribute('data-opt'), 10);
        self.mats[m][o] = t.value;
        self.update(self.hide && m === 0);
        // Show the photo of the unit that was just changed
        var mv = self.matVariants && self.matVariants[m];
        if (self.hide && m > 0 && mv && mv.media_id) document.dispatchEvent(new CustomEvent('lv:variant', { detail: { mediaId: mv.media_id } }));
        return;
      }
      if (t.closest('[data-lv-option]')) { self.resetMats(); self.renderMats(); self.update(true); }
    });
    root.addEventListener('click', function (e) {
      var add = e.target.closest('[data-lv-add]');
      if (add) { e.preventDefault(); self.add(add); }
    });
  };

  Picker.prototype.pickSize = function (code, silent) {
    var token = sizeToken(code), hit = false;
    this.groups.forEach(function (g) {
      if (!g.classList.contains('lv-opt--size')) return;
      g.querySelectorAll('input').forEach(function (inp) {
        if (sizeToken(inp.value) === token) { inp.checked = true; hit = true; }
      });
    });
    if (hit && !silent) {
      if (this.hide && this.sizeIdx > -1) {
        var self = this, info = this.optionInfo[this.sizeIdx];
        var pair = info && info.values.filter(function (p) { return sizeToken(p[0]) === token; })[0];
        if (pair) this.mats.forEach(function (vals) { vals[self.sizeIdx] = pair[0]; });
      } else {
        this.resetMats();
      }
      this.renderMats(); this.update(true);
    }
    return hit;
  };

  // One row per unit (image, "Bottle 1", a select per option) inside the selected 2 / 3 offer card
  Picker.prototype.renderMats = function () {
    var self = this;
    this.root.querySelectorAll('[data-lv-offer]').forEach(function (card) {
      var n = parseInt(card.getAttribute('data-lv-offer'), 10);
      var box = card.querySelector('[data-lv-mats]');
      if (!box) return;
      var on = self.offers && n === self.qty && (n > 1 || self.hide);
      box.hidden = !on;
      var rows = box.querySelector('[data-lv-mat-rows]');
      if (!rows) return;
      rows.innerHTML = '';
      if (!on) return;
      var unit = (self.cfg.unit && self.cfg.unit[0]) || 'bottle';
      for (var m = 0; m < n; m++) {
        var row = document.createElement('div');
        row.className = n === 1 ? 'lv-mat lv-mat--single' : 'lv-mat';
        var img = document.createElement('img');
        img.className = 'lv-mat__img'; img.alt = ''; img.width = 44; img.height = 44; img.setAttribute('data-lv-mat-img', m);
        row.appendChild(img);
        var name = document.createElement('span');
        name.className = 'lv-mat__name';
        name.textContent = unit.charAt(0).toUpperCase() + unit.slice(1) + ' ' + (m + 1);
        if (n > 1) row.appendChild(name);
        var selects = document.createElement('div');
        selects.className = 'lv-mat__selects';
        self.optionInfo.forEach(function (info, o) {
          if (!info || info.values.length < 2) return;
          var wrap = document.createElement('label');
          wrap.className = 'lv-mat__select';
          var hidden = document.createElement('span');
          hidden.className = 'lv-visually-hidden';
          hidden.textContent = name.textContent + ' ' + info.name.toLowerCase();
          wrap.appendChild(hidden);
          var sel = document.createElement('select');
          sel.setAttribute('data-lv-mat-select', '');
          sel.setAttribute('data-mat', m);
          sel.setAttribute('data-opt', o);
          info.values.forEach(function (pair) {
            var opt = document.createElement('option');
            opt.value = pair[0];
            opt.textContent = pair[2] || pair[1];
            if (self.mats[m][o] === pair[0]) opt.selected = true;
            sel.appendChild(opt);
          });
          wrap.appendChild(sel);
          selects.appendChild(wrap);
        });
        row.appendChild(selects);
        rows.appendChild(row);
      }
    });
  };

  Picker.prototype.bestOffer = function () {
    var best = 1, bestEach = Infinity;
    for (var n = 1; n <= 3; n++) {
      var each = this.prices[n] / n;
      if (each < bestEach - 0.5) { bestEach = each; best = n; }
    }
    return best > 1 ? best : 0;
  };

  Picker.prototype.update = function (userChange) {
    var self = this, cfg = this.cfg, root = this.root;
    var values = this.hide ? this.mats[0].slice() : this.selected();
    var variant = this.match(values);
    this.variant = variant;
    var qty = this.offers ? this.qty : 1;
    this.matVariants = this.mats.slice(0, qty).map(function (vals, i) { return self.match(i === 0 && !self.offers ? values : vals); });

    // Legends, and which choices can be bought together with the other selections
    this.groups.forEach(function (g, i) {
      var checked = g.querySelector('input:checked');
      var out = g.querySelector('[data-lv-option-value]');
      if (out && checked) out.textContent = checked.getAttribute('data-lv-label') || checked.value;
      g.querySelectorAll('[data-lv-choice]').forEach(function (label) {
        var inp = label.querySelector('input');
        var test = values.slice(); test[i] = inp.value;
        var v = self.match(test);
        label.classList.toggle('is-unavailable', !v || !v.available);
      });
    });

    // Per-unit rows: photo of that unit's variant, sold-out choices disabled
    root.querySelectorAll('[data-lv-mat-img]').forEach(function (img) {
      var v = self.matVariants[parseInt(img.getAttribute('data-lv-mat-img'), 10)];
      if (v && v.img && img.getAttribute('src') !== v.img) img.src = v.img;
    });
    root.querySelectorAll('[data-lv-mat-select]').forEach(function (sel) {
      var m = parseInt(sel.getAttribute('data-mat'), 10), o = parseInt(sel.getAttribute('data-opt'), 10);
      [].forEach.call(sel.options, function (opt) {
        var test = self.mats[m].slice(); test[o] = opt.value;
        var v = self.match(test);
        opt.disabled = !v || !v.available;
      });
    });

    var available = this.matVariants.length > 0 && this.matVariants.every(function (v) { return v && v.available; });
    var unitPrice = variant ? variant.price : 0;
    var compare = variant ? variant.compare : 0;
    var offerPrice = this.offers ? this.prices[qty] : unitPrice;
    var total = offerPrice + (this.insurance && cfg.insurance ? cfg.insurance.price : 0);

    document.querySelectorAll('[data-lv-price]').forEach(function (el) {
      if (!variant) return;
      el.textContent = money(el.hasAttribute('data-lv-offer-total') ? offerPrice : unitPrice);
    });
    document.querySelectorAll('[data-lv-compare]').forEach(function (el) {
      var on = variant && compare > unitPrice;
      el.hidden = !on;
      if (on) el.innerHTML = '<span class="lv-visually-hidden">Regular price</span>' + money(compare);
    });
    document.querySelectorAll('[data-lv-save]').forEach(function (el) {
      var pct = variant && compare > unitPrice ? Math.floor((compare - unitPrice) * 100 / compare) : 0;
      el.hidden = pct <= 0;
      el.textContent = pct > 0 ? 'Save ' + pct + '%' : '';
    });

    // Offer cards
    if (this.offers) {
      var unitFull = Math.max(cfg.unit_full || 0, unitPrice);
      var best = this.bestOffer();
      root.querySelectorAll('[data-lv-offer]').forEach(function (card) {
        var n = parseInt(card.getAttribute('data-lv-offer'), 10);
        var price = self.prices[n], full = unitFull * n;
        card.classList.toggle('is-selected', n === qty);
        var input = card.querySelector('[data-lv-offer-input]');
        if (input) input.checked = n === qty;
        var p = card.querySelector('[data-lv-offer-price]'); if (p) p.textContent = money(price);
        var f = card.querySelector('[data-lv-offer-full]');
        if (f) { f.textContent = money(full); f.hidden = !(full > price); }
        var s = card.querySelector('[data-lv-offer-save]');
        if (s) {
          var pct = full > price ? Math.floor((full - price) * 100 / full) : 0;
          s.textContent = pct > 0 ? 'Save ' + pct + '%' : '';
          s.hidden = pct <= 0;
        }
        var each = card.querySelector('[data-lv-offer-each]');
        if (each) { each.textContent = money(Math.round(price / n)) + ' each'; each.hidden = n === 1; }
        var ribbon = card.querySelector('[data-lv-ribbon]');
        if (ribbon) {
          var own = (cfg.ribbons && cfg.ribbons[n - 1]) || '';
          var text = own || (n === best && cfg.best_label ? cfg.best_label : '');
          ribbon.textContent = text;
          ribbon.hidden = !text;
          ribbon.classList.toggle('is-best', !own && n === best);
        }
      });
    }

    var btn = root.querySelector('[data-lv-add]');
    if (btn && !btn.hasAttribute('aria-busy')) {
      btn.disabled = !available;
      var lbl = btn.querySelector('[data-lv-btn-label]');
      if (lbl) lbl.textContent = available ? (lbl.getAttribute('data-default') || 'Add to cart') : (variant ? cfg.sold_out : cfg.unavailable) || 'Sold out';
      var bp = btn.querySelector('[data-lv-btn-price]'), sep = btn.querySelector('[data-lv-btn-sep]');
      if (bp) { bp.textContent = money(total); bp.hidden = !available; }
      if (sep) sep.hidden = !available;
    }
    document.querySelectorAll('[data-lv-sticky-add]').forEach(function (b) { if (!b.hasAttribute('aria-busy')) b.disabled = !available; });

    // Sticky bar: "2 bottles" for a bundle, otherwise the chosen option(s)
    var labels = this.hide
      ? values.map(function (val, i) { return self.label(i, val); }).filter(Boolean)
      : this.groups.map(function (g) {
        var c = g.querySelector('input:checked');
        return c ? (c.getAttribute('data-lv-label') || c.value) : '';
      }).filter(Boolean);
    var unitNames = cfg.unit || ['bottle', 'bottles'];
    var stickyText = qty > 1 ? qty + ' ' + unitNames[1] : labels.join(' · ');
    document.querySelectorAll('[data-lv-sticky-variant]').forEach(function (el) { el.textContent = stickyText; });
    document.querySelectorAll('[data-lv-sticky] [data-lv-price]').forEach(function (el) { if (variant) el.textContent = money(offerPrice); });

    var dcId = root.querySelector('[data-lv-dc-id]');
    if (dcId && variant) dcId.value = variant.id;
    var dcQty = root.querySelector('[data-lv-dc-qty]');
    if (dcQty) dcQty.value = qty;

    // Highlight the chosen size in the size guide
    var token = this.sizeIdx > -1 && values[this.sizeIdx] ? sizeToken(values[this.sizeIdx]) : '';
    document.querySelectorAll('[data-lv-sizecard]').forEach(function (c) { c.classList.toggle('is-picked', sizeToken(c.getAttribute('data-lv-sizecard')) === token); });
    document.querySelectorAll('[data-lv-size-art]').forEach(function (g) { g.classList.toggle('is-picked', sizeToken(g.getAttribute('data-lv-size-art')) === token); });

    if (userChange && variant) {
      if (variant.media_id) document.dispatchEvent(new CustomEvent('lv:variant', { detail: { mediaId: variant.media_id } }));
      if (cfg.update_url && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        url.searchParams.delete('size');
        history.replaceState(history.state, '', url.toString());
      }
    }
  };

  Picker.prototype.add = function (button) {
    var self = this, root = this.root, cfg = this.cfg;
    var mats = (this.matVariants || []).filter(Boolean);
    var error = root.querySelector('[data-lv-error]');
    if (error) error.hidden = true;
    if (!mats.length || !mats.every(function (v) { return v.available; })) return;
    var counts = {};
    mats.forEach(function (v) { counts[v.id] = (counts[v.id] || 0) + 1; });
    var buttons = [root.querySelector('[data-lv-add]')].concat([].slice.call(document.querySelectorAll('[data-lv-sticky-add]')));
    buttons.forEach(function (b) {
      if (!b) return;
      b.setAttribute('aria-busy', 'true');
      b.disabled = true;
      if (!b.hasAttribute('data-lv-html')) b.setAttribute('data-lv-html', b.innerHTML);
      b.textContent = cfg.busy_label || 'Adding…';
    });
    function done() {
      buttons.forEach(function (b) {
        if (!b) return;
        b.removeAttribute('aria-busy');
        b.disabled = false;
        if (b.hasAttribute('data-lv-html')) { b.innerHTML = b.getAttribute('data-lv-html'); b.removeAttribute('data-lv-html'); }
      });
      self.update(false);
    }
    function fail(err) {
      if (error) {
        error.textContent = (err && err.message) || 'Something went wrong. Please try again.';
        error.hidden = false;
        if (!root.contains(button)) error.scrollIntoView({ behavior: scrollBehavior(), block: 'center' });
      }
      done();
    }

    // The cart ends up holding exactly the chosen units (other variants of this product are removed) plus the optional
    // insurance, so pressing Add to Cart again never doubles the order. Kaching prices the units together at checkout.
    // A first add goes through /cart/add.js (which Shopify's add-to-cart tracking listens to); otherwise
    // /cart/update.js sets the quantities.
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var sections = null;
    if (!cfg.skip_cart && cart && typeof cart.getSectionsToRender === 'function') {
      sections = cart.getSectionsToRender().map(function (s) { return s.id; });
    }
    function post(url, body) {
      if (sections) { body.sections = sections; body.sections_url = window.location.pathname; }
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
    }
    fetch(route('cart_url', 'cart'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [] }; })
      .then(function (current) {
        var inCart = {};
        (current.items || []).forEach(function (it) { inCart[it.variant_id] = (inCart[it.variant_id] || 0) + it.quantity; });
        var mine = self.variants.some(function (v) { return inCart[v.id] > 0; });
        var insId = cfg.insurance && cfg.insurance.id;
        var insWrong = insId && !self.insurance && inCart[insId] > 0;
        if (!mine && !insWrong) {
          var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
          if (insId && self.insurance && !inCart[insId]) items.push({ id: insId, quantity: 1 });
          return post(route('cart_add_url', 'cart/add'), { items: items });
        }
        var updates = {};
        self.variants.forEach(function (v) { updates[v.id] = counts[v.id] || 0; });
        if (insId) updates[insId] = self.insurance ? 1 : 0;
        return post(route('cart_update_url', 'cart/update'), { updates: updates });
      })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || 'Could not add to cart');
        var json = res.json;
        if (cfg.skip_cart) { window.location.href = rootUrl() + 'checkout'; return; }
        if (cart && typeof cart.renderContents === 'function' && json.sections) {
          var first = mats[0];
          var line = (json.items || []).filter(function (it) { return String(it.variant_id) === String(first.id); })[0];
          if (line) { json.id = line.id; json.key = line.key; }
          cart.renderContents(json);
          cart.classList.remove('is-empty');
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || rootUrl() + 'cart';
        }
        done();
      })
      .catch(fail);
  };

  function initPickers(scope) {
    (scope || document).querySelectorAll('[data-lv-buy]').forEach(function (root) {
      if (root.getAttribute('data-lv-ready')) return;
      root.setAttribute('data-lv-ready', '1');
      root.lvPicker = new Picker(root);
    });
  }
  function picker() {
    var root = document.querySelector('[data-lv-buy]');
    return root && root.lvPicker;
  }
  // Kaching can print its deal settings after this script runs: refresh the prices once it has
  function refreshPrices() {
    document.querySelectorAll('[data-lv-buy]').forEach(function (root) {
      var p = root.lvPicker;
      if (!p || !p.offers || p.live) return;
      p.loadPrices(); p.update(false);
    });
  }

  /* ---------------------------------------------------------------
     Product gallery: swipe/scroll-snap slider with thumbnails
     --------------------------------------------------------------- */
  function initGalleries(scope) {
    (scope || document).querySelectorAll('[data-lv-gallery]').forEach(function (g) {
      if (g.getAttribute('data-lv-ready')) return;
      g.setAttribute('data-lv-ready', '1');
      var track = g.querySelector('[data-lv-track]');
      if (!track) return;
      var slides = [].slice.call(track.querySelectorAll('[data-lv-slide]'));
      var thumbs = [].slice.call(g.querySelectorAll('[data-lv-thumb]'));
      var counter = g.querySelector('[data-lv-current]');
      var prev = g.querySelector('[data-lv-prev]'), next = g.querySelector('[data-lv-next]');
      var index = 0, raf = null;
      function go(i, instant) {
        if (!slides.length) return;
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: instant ? 'auto' : scrollBehavior() });
        mark(i);
      }
      function mark(i) {
        index = i;
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (thumbs[i] && thumbs[i].parentNode.scrollWidth > thumbs[i].parentNode.clientWidth) {
          var tp = thumbs[i].parentNode;
          tp.scrollTo({ left: thumbs[i].offsetLeft - tp.clientWidth / 2 + thumbs[i].clientWidth / 2, behavior: scrollBehavior() });
        }
        if (counter) counter.textContent = i + 1;
        slides.forEach(function (s, k) {
          if (k !== i) s.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
        });
      }
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== index && i >= 0 && i < slides.length) mark(i);
        });
      }, { passive: true });
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      });
      document.addEventListener('lv:variant', function (e) {
        var id = e.detail && String(e.detail.mediaId);
        slides.forEach(function (s, k) { if (s.getAttribute('data-media-id') === id && k !== index) go(k); });
      });
      // Opened with ?variant=…: start on that variant's photo
      var p = picker();
      if (p && p.variant && p.variant.media_id && /[?&]variant=/.test(window.location.search)) {
        slides.forEach(function (s, k) { if (s.getAttribute('data-media-id') === String(p.variant.media_id)) setTimeout(function () { go(k, true); }, 0); });
      }
      mark(0);
    });
  }

  /* ---------------------------------------------------------------
     Tabs (buy box and problem section): click + arrow keys
     --------------------------------------------------------------- */
  function initTabs(scope) {
    (scope || document).querySelectorAll('[data-lv-tabs]').forEach(function (wrap) {
      if (wrap.getAttribute('data-lv-ready')) return;
      wrap.setAttribute('data-lv-ready', '1');
      var tabs = [].slice.call(wrap.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            select(tabs[n], true);
          }
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     Sticky purchase bar: shown once the purchase box has scrolled away
     --------------------------------------------------------------- */
  function initSticky() {
    var bar = document.querySelector('[data-lv-sticky]');
    var buy = document.getElementById('lv-buy');
    if (!bar || !buy) return;
    var footer = document.querySelector('.lv-footer') || document.querySelector('.shopify-section-group-footer-group');
    var price = buy.closest('.lv-info') && buy.closest('.lv-info').querySelector('.lv-price');
    var btn = bar.querySelector('[data-lv-sticky-add]');
    var early = bar.hasAttribute('data-lv-early');
    var current = null, queued = false;
    // 'buy' once the purchase box has been passed; 'jump' (phones) once the first screen has scrolled away but the box
    // is still below
    function render() {
      queued = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var box = buy.getBoundingClientRect();
      var nearFooter = footer && footer.getBoundingClientRect().top < vh;
      var mode = '';
      if (!nearFooter) {
        if (box.bottom < 0) mode = 'buy';
        else if (early && window.innerWidth < 990 && box.top > vh && (window.scrollY > vh * 0.8 || (price && price.getBoundingClientRect().bottom < 0))) mode = 'jump';
      }
      if (mode === current) return;
      current = mode;
      bar.classList.toggle('is-on', !!mode);
      bar.classList.toggle('is-jump', mode === 'jump');
      bar.setAttribute('aria-hidden', mode ? 'false' : 'true');
      if (mode) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      document.body.classList.toggle('lv-sticky-on', !!mode);
      if (btn && !btn.hasAttribute('aria-busy')) {
        var label = btn.getAttribute(mode === 'jump' ? 'data-label-jump' : 'data-label-buy');
        if (label) btn.textContent = label;
      }
    }
    function queue() { if (!queued) { queued = true; setTimeout(render, 60); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    render();
    bar.addEventListener('click', function (e) {
      var add = e.target.closest('[data-lv-sticky-add]');
      if (!add) return;
      e.preventDefault();
      if (current === 'jump') {
        var target = buy.querySelector('#bundles') || buy;
        target.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
        return;
      }
      var p = buy.lvPicker;
      if (p) p.add(add);
    });
  }

  /* ---------------------------------------------------------------
     In-page links (hidden when their section isn't on the page)
     --------------------------------------------------------------- */
  function initLinks() {
    document.querySelectorAll('[data-lv-jump] a[href^="#"]').forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      if (id && !document.getElementById(id)) (a.closest('li') || a).hidden = true;
    });
    document.querySelectorAll('.lv-gallery__links a[href^="#"]').forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      if (id && !document.getElementById(id)) a.hidden = true;
    });
    document.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-lv-pick-size]');
      if (pick) {
        var p = picker();
        if (p && p.pickSize(pick.getAttribute('data-lv-pick-size'))) {
          e.preventDefault();
          var buy = document.getElementById('lv-buy');
          if (buy) buy.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
        }
        return;
      }
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
      if (history.replaceState) history.replaceState(history.state, '', '#' + id);
    });
  }

  /* ---------------------------------------------------------------
     Stars under the title: filled from the Reviews section's genuine reviews (average only, never a count)
     --------------------------------------------------------------- */
  function initRating() {
    var src = document.querySelector('[data-lv-reviews-avg]');
    if (!src) return;
    var avg = parseFloat(src.getAttribute('data-lv-reviews-avg'));
    if (!(avg > 0)) return;
    document.querySelectorAll('[data-lv-rating]').forEach(function (el) {
      var t = el.querySelector('[data-lv-rating-text]');
      if (t && !t.textContent.trim()) t.textContent = avg.toFixed(1) + ' out of 5';
      el.hidden = false;
    });
  }

  /* ---------------------------------------------------------------
     Rotating top bar messages (one at a time on small screens)
     --------------------------------------------------------------- */
  function initBar() {
    document.querySelectorAll('[data-lv-rotate]').forEach(function (track) {
      if (track.getAttribute('data-lv-ready')) return;
      track.setAttribute('data-lv-ready', '1');
      var msgs = track.querySelectorAll('.lv-bar__msg');
      if (msgs.length < 2 || reduceMotion) return;
      var i = 0, secs = parseInt(track.getAttribute('data-lv-rotate'), 10) || 4;
      setInterval(function () {
        if (track.classList.contains('lv-bar__track--row') && window.innerWidth >= 990) return;
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, secs * 1000);
    });
  }

  function init(scope) {
    initPickers(scope);
    initGalleries(scope);
    initTabs(scope);
    initBar();
  }
  function start() {
    init(document);
    initSticky();
    initLinks();
    initRating();
    setTimeout(refreshPrices, 600);
    setTimeout(refreshPrices, 2000);
    window.addEventListener('load', refreshPrices);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  // Theme editor: re-initialise sections when they are added or changed
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initRating(); });
})();
